import dynamic from 'next/dynamic';

export default dynamic(() => import('./Select'), { ssr: false });
